import { Box } from "@mui/material";
import React from "react";
import theme from "../../assets/theme/theme";
import { getPrivacyPolicyUrl } from "../../utils/environment";
import AppBarV2 from "../AppBarV2";
import PDFViewerV2 from "../PDFViewerV2";

export interface Props {}

const PrivacyPolicy: React.FC<Props> = (props) => {
  return (
    <Box>
      <AppBarV2 />
      {/* classname=main */}
      <Box
        sx={{
          marginTop: "70px",
          marginBottom: "70px",
          paddingTop: "64px",
          paddingLeft: "100px",
          paddingRight: "100px",
          position: "relative",
          paddingBottom: "20px",
          [theme.breakpoints.down("md")]: {
            marginTop: "20px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <PDFViewerV2 url={getPrivacyPolicyUrl()} />
        </Box>
      </Box>
    </Box>
  );
};

export default PrivacyPolicy;
